export default __webpack_public_path__ + "static/map-834c7f6ba03648e2a68d4c742e1745e2.png";